var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["type", "button", "class", "close"]
var __target

module.exports = function description (ctrl) {
  __target = ctrl.items
  if (__target) {
    ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
      var item = $value
      var $key = "f7ebb78c-2fd5-4960-b5ec-95a99ef8be30_" + $item
      elementOpen("div", $key, null, "class", "alert alert-" + (item.type) + " alert-dismissible")
        elementOpen("button", "e1072061-c814-4543-9b14-389fec9eb5c5_" + $key, hoisted1, "onclick", function ($event) {
          var $element = this;
        ctrl.items.splice($item, 1)})
          text("×")
        elementClose("button")
        elementOpen("h4")
          elementOpen("i", null, null, "class", "icon fa fa-" + (item.icon) + "")
          elementClose("i")
          text(" " + (item.title) + "")
        elementClose("h4")
        text(" \
            " + (item.message) + " \
          ")
      elementClose("div")
    }, this)
  }
}
